// src/pages/RecommendationsPage.js
import React, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { CircularProgress, Container } from '@mui/material';
import Recommendations from '../Components/Recommendations';
import logger from '../utils/logger';

const RecommendationsPage = () => {
  const [familyBoardId, setFamilyBoardId] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const fetchFamilyBoardId = async () => {
      if (!auth.currentUser) {
        setLoading(false);
        return;
      }

      try {
        const userDoc = await getDoc(doc(db, 'users', auth.currentUser.uid));
        if (userDoc.exists()) {
          const userData = userDoc.data();
          setFamilyBoardId(userData.familyCode || 'default');
        }
      } catch (error) {
        logger.error('Error fetching family board ID:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchFamilyBoardId();
  }, [auth.currentUser, db]);

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, display: 'flex', justifyContent: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (!familyBoardId) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        <div>Please set up your family code in your profile.</div>
      </Container>
    );
  }

  return (
    <div className="recommendations-page">
      <Recommendations familyBoardId={familyBoardId} />
    </div>
  );
};

export default RecommendationsPage;
